import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Input } from 'antd';
import Cell from '../../Cell/Cell';
import { phoneFieldValueSelector } from '../../../store/selectors';
import { setPhoneFieldPos, setPhoneFieldValue } from '../../../store/actions';
import {
  notDraggableClass,
  phoneFieldDataAttrFocus,
} from '../../../constants/common';

const PhoneNumberInput = () => {
  const dispatch = useDispatch();

  const phoneFieldValue = useSelector(phoneFieldValueSelector);

  const setCursorPos = (e) => {
    dispatch(setPhoneFieldPos(e.target.selectionStart));
  };

  const handleChange = (e) => {
    dispatch(setPhoneFieldValue(e.target.value));
    setCursorPos(e);
  };

  return (
    <Cell
      className={notDraggableClass}
      title="Номер"
      htmlFor="phoneNum"
      content={
        <Input
          data-focus={phoneFieldDataAttrFocus}
          onChange={handleChange}
          onSelect={setCursorPos}
          value={phoneFieldValue}
          id="phoneNum"
          type="tel"
        />
      }
    />
  );
};

export default PhoneNumberInput;
